import { render } from "./Units_List.vue?vue&type=template&id=1a5e06c8"
import script from "./Units_List.vue?vue&type=script&lang=js"
export * from "./Units_List.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__